import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ items }) {
  const list = items && items.length ? items : ["Strategia AI", "Automazione", "Innovazione"];
  return (
    <div className="border-y border-white/10 py-10 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {list.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-black uppercase tracking-tight text-5xl md:text-7xl mx-8 ${
                i % 2 === 0 ? "text-white/90" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="w-3 h-3 bg-[#007AFF] rotate-45 mx-4 shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
